module.exports = __webpack_public_path__ + "img/arrow-square-up-right-light.669acf7.svg";